export interface IEmphasisProps {
    [key: string]: number | string;
}

export interface IEmphasis {
    [key: string]: IEmphasisProps;
}

export const Emphasis: IEmphasis = {
    high: { value: 0.88, className: '' }, // No className because it has emphasis High by default
    medium: { value: 0.64, className: 'elc-medium-emphasis' },
    light: { value: 0.12, className: 'elc-light-emphasis' },
    pale: { value: 0.02, className: 'elc-pale-emphasis' },
    disabled: { value: 0.4, className: 'elc-disabled-emphasis' }
};
